import { RefreshOutlined } from '@teko/ds-icon';
import { Button, styled } from '@teko/ui';
import { t } from 'i18n';

export interface HamperTabsProps {
  onClickTab?: (tab: number) => void;
  onResetConfig?: () => void;
  lsActiveTab?: number;
}
const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  a {
    text-decoration: unset;
  }
`;
const RightWrapper = styled.div`
  margin-top: 8px;
`;
const StyledButton = styled(Button)`
  margin-right: 0.5rem;
  margin-top: 8px;
`;

export const HamperTabs = ({
  onClickTab,
  onResetConfig,
  lsActiveTab,
  ...props
}: HamperTabsProps) => {
  const {} = props;

  return (
    <Wrapper {...props}>
      <div>
        {Array(5)
          .fill(null)
          .map((_, index: number) => (
            <StyledButton
              variant={index === lsActiveTab ? 'primary' : 'normal'}
              onClick={(): void => {
                onClickTab && onClickTab(index);
              }}
              key={index}
            >
              {t('Giỏ quà tự chọn')} {index + 1}
            </StyledButton>
          ))}
      </div>
      <RightWrapper>
        <Button variant="primary" onClick={onResetConfig}>
          {t('Tạo lại')}
          <RefreshOutlined
            color="white"
            size={16}
            style={{ marginLeft: '0.5rem' }}
          />
        </Button>
      </RightWrapper>
    </Wrapper>
  );
};
